import { CardActionLink, IllustrationNetwork } from '@coverflex-tech/hypernova';
import { Href, useRouter } from 'expo-router';

export type TCardNetworkWidgetProps = {
  title: string;
  description?: string;
  route: Href;
};

export function CardNetworkWidget({
  title,
  description,
  route,
}: TCardNetworkWidgetProps) {
  const router = useRouter();
  return (
    <CardActionLink
      title={title}
      description={description}
      backgroundColor="accentPrimary10"
      onClick={() => {
        router.push(route as Href);
      }}
      illustration={{
        asset: <IllustrationNetwork />,
      }}
    />
  );
}
